import { ScrollableCard } from "@mc/mc-legacy";
import React from "react";
import * as PropTypes from "prop-types";
import "./MenuPanel.scss";
/**
 * Panel obsahující menu.
 */

class MenuPanel extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  render() {
    const { children } = this.props;
    return <div className="menu-panel">{children}</div>;
  }
}

export default MenuPanel;
